export default "__VITE_ASSET__CixPSP5I__"